

















import Vue from 'vue';
import {
  Component, Emit, Prop, Watch, Provide,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { Mutation, State } from 'vuex-class';
import {
  KPortalHeader,
  KAppToolbar,
  KAppToolbarBtn,
  KNoticeContainer,
  KNavigationDrawer,
  KSelectFi,
} from '@kasasa/fbase-components';
import router from '@/router';
import menuDefinitions from '@/menu';
import {
  MenuItem,
  MenuHeading,
  Alert,
  NoticeClass,
  AuthStore,
} from '@kasasa/fbase-components/lib';
import { AccountRelationshipSearchResource } from '@/api/relationshipsearch';
import { ConsumerAccountDetailsResource } from '@/api/consumeraccountdetails';
import { AccountQualificationDetailsResource } from '@/api/accountqualificationdetails';
import { CycleResource } from '@/api/cycles';
import { RewardDetailsResource } from '@/api/rewarddetails';
import { InControlDetailsResource } from '@/api/incontroldetails';
import { QualOverrideResource } from '@/api/qualoverride/QualOverrideResource';
import { TransactionDetailsResource } from '@/api/transactiondetails/TransactionDetailsResource';
import { ATMSettingsResource } from '@/api/atm/ATMSettingsResource';
import { GrantResource } from '@/api/grant/GrantResource';
import { JobExecutionResource } from '@/api/jobexecutions/JobExecutionResource';
import { FileLoadHistoryResource } from '@/api/fileloadhistory/FileLoadHistoryResource';
import { ImportSummaryResource } from '@/api/importsummary/ImportSummaryResource';
import { FiConfigurationResource } from '@/api/reports/FiConfigurationResource';
import { ReportResource } from '@/api/reports/ReportResource';
import { QualificationSummaryResource } from '@/api/qualificationsummary/QualificationSummaryResource';
import { RewardSummaryResource } from '@/api/rewardsummary/RewardSummaryResource';
import { TunesSummaryResource } from '@/api/tunessummary/TunesSummaryResource';
import { AuditMessageResource } from '@/api/auditmessages/AuditMessageResource';
import { InterestSettingsResource } from '@/api/interestsettings/InterestSettingsResource';
import { ProductResource } from '@/api/product/ProductResource';
import {
  RewardsValidationResource, SweepFileResource, PostingFileResource, SnapshotApprovalResource, SweepFileApprovalResource,
} from '@/api/rewardsvalidation';
import { CoreUserInfoResource } from '@/api/coreuserinfo/CoreUserInfoResource';
import { ReloadResource } from '@/api/reload/ReloadResource';
import { RecompResource } from '@/api/recomp/RecompResource';

@Component({
  components: {
    KPortalHeader,
    KNavigationDrawer,
    KNoticeContainer,
    KAppToolbar,
    KSelectFi,
  },
  computed: mapState(['auth', 'fiId']),
})
export default class App extends Vue {
  appTitle: string = 'Rewards Processing';

  fiId!: string;

  auth!: AuthStore;

  @Provide('AccountRelationshipSearchResource')
  accountRelationshipSearchResource: AccountRelationshipSearchResource = new AccountRelationshipSearchResource(
    this.$store,
  );

  @Provide('ConsumerAccountDetailsResource')
  consumerAccountDetailsResource: ConsumerAccountDetailsResource = new ConsumerAccountDetailsResource(
    this.$store,
  );

  @Provide('AccountQualificationDetailsResource')
  accountQualificationDetailsResource: AccountQualificationDetailsResource = new AccountQualificationDetailsResource(
    this.$store,
  );

  @Provide('CycleResource')
  cycleResource: CycleResource = new CycleResource(this.$store);

  @Provide('RewardDetailsResource')
  rewardDetailsResource: RewardDetailsResource = new RewardDetailsResource(
    this.$store,
  );

  @Provide('ReloadResource')
  reloadResource: ReloadResource = new ReloadResource(
    this.$store,
  );

  @Provide('InControlDetailsResource')
  inControlDetailsResource: InControlDetailsResource = new InControlDetailsResource(
    this.$store,
  );

  @Provide('QualOverrideResource')
  qualOverrideResource: QualOverrideResource = new QualOverrideResource(
    this.$store,
  );

  @Provide('TransactionDetailsResource')
  transactionDetailsResource: TransactionDetailsResource = new TransactionDetailsResource(
    this.$store,
  );

  @Provide('ATMSettingsResource')
  atmSettingsResource: ATMSettingsResource = new ATMSettingsResource(
    this.$store,
  );

  @Provide('GrantResource')
  grantResource: GrantResource = new GrantResource(this.$store);

  @Provide('JobExecutionResource')
  jobExecutionResource: JobExecutionResource = new JobExecutionResource(this.$store);

  @Provide('FileLoadHistoryResource')
  fileLoadHistoryResource: FileLoadHistoryResource = new FileLoadHistoryResource(this.$store);

  @Provide('ImportSummaryResource')
  importSummaryResource: ImportSummaryResource = new ImportSummaryResource(this.$store);

  @Provide('FiConfigurationResource')
  fiConfigurationResource: FiConfigurationResource = new FiConfigurationResource(this.$store);

  @Provide('ReportResource')
  reportResource: ReportResource = new ReportResource(this.$store);

  @Provide('QualificationSummaryResource')
  qualificationSummaryResource: QualificationSummaryResource = new QualificationSummaryResource(this.$store);

  @Provide('RewardSummaryResource')
  rewardSummaryResource: RewardSummaryResource = new RewardSummaryResource(this.$store);

  @Provide('TunesSummaryResource')
  tunesSummaryResource: TunesSummaryResource = new TunesSummaryResource(this.$store);

  @Provide('AuditMessageResource')
  auditMessageResource: AuditMessageResource = new AuditMessageResource(this.$store);

  @Provide('InterestSettingsResource')
  interestSettingsResource: InterestSettingsResource = new InterestSettingsResource(this.$store);

  @Provide('ProductResource')
  productResource: ProductResource = new ProductResource(this.$store);

  @Provide('RewardsValidationResource')
  rewardsValidationResource: RewardsValidationResource = new RewardsValidationResource(this.$store);

  @Provide('PostingFileResource')
  postingFileResource: PostingFileResource = new PostingFileResource(this.$store);

  @Provide('SweepFileResource')
  sweepFileResource: SweepFileResource = new SweepFileResource(this.$store);

  @Provide('CoreUserInfoResource')
  coreUserInfoResource: CoreUserInfoResource = new CoreUserInfoResource(this.$store);

  @Provide('SnapshotApprovalResource')
  snapshotApprovalResource: SnapshotApprovalResource = new SnapshotApprovalResource(this.$store);

  @Provide('SweepFileApprovalResource')
  sweepFileApprovalResource: SweepFileApprovalResource = new SweepFileApprovalResource(this.$store);

  @Provide('RecompResource')
  recompResource: RecompResource = new RecompResource(
    this.$store,
  );

  menuItems!: (MenuItem | MenuHeading)[];

  @Emit('error')
  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }

  @Mutation('fiId') mutationFi: any;

  @Mutation('isFiUser') mutationIsFiUser: any;

  drawer: boolean = true;

  mounted() {
    this.onNewRoute();
    this.buildMenu();
  }

  @Watch('$route')
  @Watch('auth', { deep: true })
  onNewRoute() {
    if (this.$route.name !== 'incomingredirect') {
      if (this.auth.sessionData && this.auth.sessionData.fkAuthLevel === 'client') {
        // This is an fi-level user, so set the fi from their session and ignore anything from the url
        const fiId = this.auth.sessionData.crmId;
        this.mutationFi(fiId);
        this.mutationIsFiUser(true);
      } else if (this.auth.headerData) {
        this.mutationIsFiUser(false);
        // Header data may not have been loaded yet, so hold off until it is so we can do clientId=>fiId lookup
        const clientId = this.$route.params.clientId;
        let fiId: string | null = null;
        if (clientId) {
          fiId = this.fiIdFromClientId(Number(clientId));
          this.mutationFi(fiId);
        }
      }
    }
  }

  readonly namesOfMenuItemsNotVisibleToFiUsers: ReadonlySet<string> = new Set<string>(['rewardsvalidation',
    'auditmessages', 'jobexecutions', 'recompsummary']);

  @Watch('auth', { deep: true })
  buildMenu() {
    this.menuItems = [];
    if (this.auth.sessionData) {
      if (this.auth.sessionData.fkAuthLevel === 'client') {
        // Client user so filter out rewards validations and audit messages
        menuDefinitions.forEach((item: MenuItem | MenuHeading) => {
          if ((item as MenuItem).to && !this.namesOfMenuItemsNotVisibleToFiUsers.has(((item as MenuItem).to as any).name)) {
            this.menuItems.push(item);
          }
        });
      } else {
        this.menuItems = [...menuDefinitions];
      }
    }
  }

  fiIdFromClientId(clientId: number): string | null {
    let fiId: number | null = null;
    if (this.auth && this.auth.headerData) {
      for (let i: number = 0; i < this.auth.headerData.fis.length; i++) {
        // The linter insists on '===' here but that doesn't find a match. Not sure why.
        // Even defining fiId as number|null, the same as in the fi class, doesn't help.
        /* eslint-disable eqeqeq */
        if (this.auth.headerData.fis[i].id == clientId) {
          /* eslint-enable eqeqeq */
          fiId = this.auth.headerData.fis[i].fiId;
          break;
        }
      }
    }

    return fiId !== null ? fiId.toString() : null;
  }
}
